import React from 'react';
import {
  Box,
} from '@mui/material';
const LogoHeader = (
  
) => {

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '10px 0'
    }}>
      <img src="assets/images/logo.svg" alt="logo" data-testid='infovist-logo'/>
    </Box>
  );
}

export default LogoHeader;
